if (!window.customSimLogicLoaded) {

  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;

    const simSelector = form.querySelector('.sim-selection-container');

    if (!simSelector || simSelector.dataset.requiresSim !== 'true') return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const simInput = form.querySelector('input[name="sim-id"]:checked');
    const isLocked = simSelector.dataset.networkLocked === 'y';

    if (!simInput) {
      alert(isLocked
        ? 'This device\'s network SIM is currently unavailable. Please contact support.'
        : 'Please select a Network SIM to continue.');
      return;
    }

    const idInput = form.querySelector('[name="id"]:not(:disabled)') || form.querySelector('[name="id"]');
    const handsetVariantId = parseInt(idInput ? idInput.value : form.dataset.productId, 10);
    const simVariantId = parseInt(simInput.value, 10);
    const bundleId = Date.now().toString();

    const itemsArray = [
      { id: handsetVariantId, quantity: 1, properties: { _bundle_id: bundleId } },
      { id: simVariantId,     quantity: 1, properties: { _bundle_id: bundleId } }
    ];

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsArray })
    })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(err) { throw err; });
      window.location.href = '/cart';
    })
    .catch(function(error) {
      console.error('SIM bundle add to cart failed:', error);
      alert('There was a problem adding to cart. Please try again.');
    });

  }, true);

  if (!customElements.get('sim-selector')) {
    class SimSelector extends HTMLElement {
      constructor() {
        super();
        this.container = null;
        this.nameDisplay = null;
        this.variantNetworks = {};
        this.simProducts = [];
        this.productId = null;
      }

      connectedCallback() {
        this.container = this.querySelector('.sim-options');
        this.nameDisplay = this.querySelector('.selected-sim-name');
        this.lockedMsg = this.querySelector('.locked-message-container');
        this.lockedNetworkName = this.querySelector('.locked-network-name');
        
        const productIdAttr = this.getAttribute('data-product-id');
        this.isLocked = this.getAttribute('data-network-locked') === 'y';

        if (!productIdAttr || !this.container) return;
        this.productId = productIdAttr;

        try {
          const networksScript = this.querySelector('script[data-sim-networks]');
          const productsScript = this.querySelector('script[data-sim-products]');
          
          if (networksScript) this.variantNetworks = JSON.parse(networksScript.textContent);
          if (productsScript) this.simProducts = JSON.parse(productsScript.textContent).filter(Boolean);
        } catch (err) {
          console.error('[SIM selector] failed to parse SIM data:', err);
          return;
        }

        const form = this.closest('form[action$="/cart/add"]');
        if (form) {
          const idInput = form.querySelector('[name="id"]');
          if (idInput) {
            this.renderSims(idInput.value);
            const observer = new MutationObserver(() => this.renderSims(idInput.value));
            observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
          }
        }

        this.onVariantChange = this.onVariantChange.bind(this);
        if (window.MinimogEvents) {
          window.MinimogEvents.subscribe(this.productId + '__VARIANT_CHANGE', this.onVariantChange);
        }
        if (window.Foxify && window.Foxify.Events) {
          window.Foxify.Events.subscribe(this.productId + '__VARIANT_CHANGE', this.onVariantChange);
        }
      }

      onVariantChange(variant) {
        if (variant && variant.id) this.renderSims(variant.id);
      }

      renderSims(variantId) {
        const variantData = this.variantNetworks[String(variantId)] || {};
        const networks = variantData.networks || [];
        const isUnbundled = !!variantData.isUnbundled;
        const isBundledFixed = !this.isLocked && !isUnbundled;

        this.dataset.requiresSim = (this.isLocked || isUnbundled) ? 'true' : 'false';

        this.style.display = 'block';

        this.container.innerHTML = '';
        let matches = 0;

        if (this.lockedMsg) this.lockedMsg.style.display = 'none';

        this.simProducts.forEach((sim) => {
          if (this.networkMatchesBrand(networks, sim.brand)) {
            if (this.isLocked) {
              if (matches > 0) return;

              const itemDiv = document.createElement('div');
              itemDiv.className = 'sim-option-item locked';
              itemDiv.style.height = '42px';
              itemDiv.style.padding = '8px 15px';

              const lockedInput = document.createElement('input');
              lockedInput.type = 'radio';
              lockedInput.name = 'sim-id';
              lockedInput.value = sim.variantId;
              lockedInput.checked = true;
              lockedInput.hidden = true;
              itemDiv.appendChild(lockedInput);

              const lockIcon = document.createElement('div');
              lockIcon.className = 'lock-icon-circle';
              lockIcon.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>`;
              itemDiv.appendChild(lockIcon);

              if (sim.image && !sim.image.includes('no-image')) {
                const img = document.createElement('img');
                img.src = sim.image;
                img.alt = sim.brand;
                itemDiv.appendChild(img);
              } else {
                const span = document.createElement('span');
                span.textContent = sim.brand;
                span.style.fontWeight = 'bold';
                itemDiv.appendChild(span);
              }

              this.container.appendChild(itemDiv);

              if (this.lockedMsg) {
                this.lockedMsg.style.display = 'flex';
                if (this.lockedNetworkName) this.lockedNetworkName.textContent = sim.brand;
              }
              if (this.nameDisplay) this.nameDisplay.textContent = sim.brand;
              
              matches++;
            } else if (isBundledFixed) {
              if (matches > 0) return;

              const itemDiv = document.createElement('div');
              itemDiv.className = 'sim-option-item bundled-fixed';
              itemDiv.style.height = '42px';
              itemDiv.style.padding = '8px 15px';

              const bundledInput = document.createElement('input');
              bundledInput.type = 'radio';
              bundledInput.name = 'sim-id';
              bundledInput.value = sim.variantId;
              bundledInput.checked = true;
              bundledInput.hidden = true;
              itemDiv.appendChild(bundledInput);

              if (sim.image && !sim.image.includes('no-image')) {
                const img = document.createElement('img');
                img.src = sim.image;
                img.alt = sim.brand;
                itemDiv.appendChild(img);
              } else {
                const span = document.createElement('span');
                span.textContent = sim.brand;
                span.style.fontWeight = 'bold';
                itemDiv.appendChild(span);
              }

              this.container.appendChild(itemDiv);
              if (this.nameDisplay) this.nameDisplay.textContent = sim.brand;

              matches++;
            } else {
              const label = document.createElement('label');
              label.className = 'sim-option-item' + (matches === 0 ? ' active' : '');
              label.style.height = '42px';
              label.style.padding = '8px 15px';
              label.style.border = '1px solid #E0E0E0';
              
              const input = document.createElement('input');
              input.type = 'radio';
              input.name = 'sim-id';
              input.value = sim.variantId;
              input.required = true;
              
              if (matches === 0) {
                input.checked = true;
                if (this.nameDisplay) this.nameDisplay.textContent = sim.brand;
              }

              if (sim.image && !sim.image.includes('no-image')) {
                const img = document.createElement('img');
                img.src = sim.image;
                img.alt = sim.brand + ' SIM';
                label.appendChild(img);
              } else {
                const span = document.createElement('span');
                span.textContent = sim.brand;
                span.style.fontWeight = 'bold';
                label.appendChild(span);
              }

              label.appendChild(input);
              
              label.addEventListener('click', () => {
                this.container.querySelectorAll('.sim-option-item').forEach(el => el.classList.remove('active'));
                label.classList.add('active');
                input.checked = true;
                if (this.nameDisplay) this.nameDisplay.textContent = sim.brand;
              });

              this.container.appendChild(label);
              matches++;
            }
          }
        });

        if (matches === 0) {
          this.dataset.requiresSim = 'false';
          if (isBundledFixed) {
            this.style.display = 'none';
          } else {
            this.container.innerHTML = '<span class="sim-no-match">No matching SIM cards available for this variant.</span>';
          }
          if (this.nameDisplay) this.nameDisplay.textContent = '';
        } else {
          this.dataset.requiresSim = 'true';
        }
      }

      networkMatchesBrand(networks, brand) {
        if (!networks || !brand) {
          return false;
        }
        if (!Array.isArray(networks)) {
          networks = String(networks).replace(/ • /g, '|').split('|');
        }
        const brandLower = brand.toLowerCase().trim();

        return networks.some(net => {
          const n = (net || '').toLowerCase().trim();
          return n !== '' && (n === brandLower || n.includes(brandLower));
        });
      }
    }
    customElements.define('sim-selector', SimSelector);
  }

  window.customSimLogicLoaded = true;
}